import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/services/auth-service.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/authentication/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  const role = authService.getRole();
  const targetUrl = state.url;

  // Allow access to /pages/* (role guard handles per-page restrictions)
  if (targetUrl.startsWith('/pages')) {
    return true;
  }

  // Allow access to the user's own dashboard
  switch (role) {
    case 'SuperAdmin':
    case 'Admin':
      if (targetUrl.startsWith('/dashboards/admin')) return true;
      break;
    case 'Vendor':
      if (targetUrl.startsWith('/dashboards/vendor')) return true;
      break;
    case 'Customer':
      if (targetUrl.startsWith('/dashboards/customer')) return true;
      break;
    case 'FarmManager':
    case 'PrincipalFarmManager':
      if (targetUrl.startsWith('/dashboards/farm-manager-dashboard')) return true;
      break;
    case 'Tester':
      if (targetUrl.startsWith('/dashboards/tester')) return true;
      break;
    case 'Consultant':
      if (targetUrl.startsWith('/dashboards/consultant')) return true;
      break;
    default:
      return router.createUrlTree(['/authentication/access-denied']);
  }

  // If trying to access a dashboard that isn't theirs, redirect to their own
  return router.createUrlTree([authService.getDefaultRoute()]);
};
